/**
 * Account-scoped in-app inbox via MobileService:
 * GET/POST /v1/ib/notifications* (filtered by active Conta).
 */

import { fetchAxios } from "../API/fetchAxios";
import { getStoredSelectedAccountId } from "../Constants/accountTypes";

const extractItems = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.list)) return payload.list;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

/** Active Conta from header selector — required so inbox never mixes accounts. */
const activeAccountQuery = () => {
  const accountId = getStoredSelectedAccountId();
  if (accountId == null || accountId === "") return {};
  return { account_id: String(accountId) };
};

export const mapIbNotification = (row) => {
  if (!row) return null;
  const id = String(row.id ?? row.Id ?? "");
  if (!id) return null;

  return {
    id,
    title: row.title ?? row.Title ?? row.short_content ?? "",
    message:
      row.description ??
      row.Description ??
      row.message ??
      row.content ??
      "",
    createdAt: row.created_at ?? row.CreatedAt ?? row.date ?? null,
    read: Boolean(row.read ?? row.Read ?? row.is_read ?? row.IsRead),
    type: row.type ?? row.Type ?? null,
    accountId: row.account_id ?? row.AccountId ?? null,
  };
};

export const fetchIbNotifications = async (take = 50) => {
  const response = await fetchAxios({
    verb: "GET",
    context: "ibNotifications",
    queryParameters: { take, ...activeAccountQuery() },
    responseType: "",
    cancelToken: undefined,
  });
  return extractItems(response?.data ?? response)
    .map(mapIbNotification)
    .filter(Boolean);
};

export const fetchIbUnreadNotificationCount = async () => {
  const response = await fetchAxios({
    verb: "GET",
    context: "ibNotificationsUnreadCount",
    queryParameters: activeAccountQuery(),
    responseType: "",
    cancelToken: undefined,
  });
  const data = response?.data ?? response;
  const count = Number(data?.count ?? data?.qty ?? 0);
  return Number.isFinite(count) ? count : 0;
};

export const markIbNotificationRead = async (id) => {
  await fetchAxios({
    verb: "POST",
    context: "ibNotificationRead",
    id: String(id),
    afterID: "read",
    responseType: "",
    cancelToken: undefined,
  });
};

export const markAllIbNotificationsRead = async () => {
  const response = await fetchAxios({
    verb: "POST",
    context: "ibNotificationsReadAll",
    queryParameters: activeAccountQuery(),
    responseType: "",
    cancelToken: undefined,
  });
  return Number(response?.data?.updated ?? response?.updated ?? 0);
};
